// Need to replace the hardcoded time with dynamic one calculated by the token expiration time,
// the actual timeout its 2 minutes, and the prompt is displayed in 1:30 min

export const TIMEOUT_END_SESSION = Number(process.env.REACT_APP_PROMPT_TIMEOUT_END_SESSION || 1200) * 1000; // milliseconds
export const PROMPT_TIMEOUT_END_SESSION = Number(process.env.REACT_APP_EXTEND_LOGOUT_TIMER || 90) * 1000; // milliseconds
export const COUNTDOWN_TIMER = Number(process.env.REACT_APP_SESSION_COUNTDOWN_TIMER) || 90;
export const TIME_FOR_IDLE = Number(process.env.REACT_APP_EXTEND_LOGOUT_TIMER) / 60 || 2;
